import { render, staticRenderFns } from "./LiveRankEnd.vue?vue&type=template&id=0870946e&scoped=true"
import script from "./LiveRankEnd.vue?vue&type=script&lang=js"
export * from "./LiveRankEnd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0870946e",
  null
  
)

export default component.exports